angular.module('bookAndPay').factory('BookAndPayService', ["$http", "DataService", "flash", "$timeout", function($http, DataService, flash, $timeout) {
  return {
    isExpired: function(cart, withRedirect) {
      if (cart.expired_by_system_time) {
        return true;
      }
      if (moment(cart.expires_at).isBefore(moment())) {
        cart.expired_by_system_time = true;
        this.expireCart(cart, withRedirect);
        return true;
      }
    },
    expireCart: function(cart, withRedirect) {
      var url;
      url = `/websites/${DataService.domain}/book_and_pay/carts/${cart.cart_uuid}/expire_cart`;
      return $http.put(url).then(function(response) {
        if (withRedirect) {
          flash.error = response.data.message || "Your cart has expired.";
          return $timeout(function() {
            return window.location.href = response.data.redirect_url;
          }, 2000);
        }
      });
    }
  };
}]);
